import React, { useRef } from 'react';
import { Canvas } from 'react-three-fiber';
import { Box } from "rebass";
import Scene from "./scene";
import { useColorMode } from "theme-ui";

const QuiSommesNous = ({ setActiveModal, active, mappedProfiles }) => {
	const wrapperRef = useRef(null);
	const [colorMode] = useColorMode();

	return (
		<Box width="100%" height="100%" ref={wrapperRef}>
			<Canvas
				camera={{ position: [0, 0, 50], fov: 45, near: 0.1, far: 10000 }}
				pixelRatio={typeof window === 'undefined' ? 1 : window.devicePixelRatio}
			>
				<Scene mappedProfiles={mappedProfiles} colorMode={colorMode} wrapperRef={wrapperRef} setActiveModal={setActiveModal} active={active} />
			</Canvas>
		</Box>
	)
};

export default QuiSommesNous;